import '../styles/index.scss';
import 'slick-carousel/slick/slick';
import 'bootstrap';

class Main {
    constructor() {
        this.onDOMLoaded();
        this.onDocumentLoad();
        this.onResize();
        this.onScroll();
        window.jQuery = window.$ = $;
    }

    onDocumentLoad() {
        window.addEventListener("load", (event) => {

        });
    }

    onDOMLoaded() {
        document.addEventListener("DOMContentLoaded", (event) => {
            if (window.innerWidth < 768) {
                const printerFloatingBtn = document.querySelector('.printer__btn');
                const footer = document.querySelector('.footer');

                if (printerFloatingBtn) {
                    window.addEventListener('scroll', () => {
                        const footerPosition = footer.getBoundingClientRect().top + window.scrollY;
                        const scrollPosition = window.scrollY + window.innerHeight;
                        printerFloatingBtn.style.position = (scrollPosition >= footerPosition) ? 'relative' : 'fixed';
                    });
                }
            }
        });

    }

    onResize() {
        window.addEventListener('resize', (event) => {

        });
    }
    onScroll() {
        window.addEventListener('scroll', (event) => {
        });
    }

}

new Main();


